import { OpeningTimeSlot } from './OpeningTimeSlot';

interface OpeningTimeDayData {
  h24: boolean;
  hours: OpeningTimeSlot[];
}

export class OpeningTimeDay {
  private readonly h24: boolean;
  private readonly hours: OpeningTimeSlot[];

  constructor(data: OpeningTimeDayData) {
    this.h24 = data.h24;
    this.hours = data.hours;
  }

  get formattedOpeningTimeSlots(): string {
    if (this.h24) {
      return "Open 24h";
    } else if (this.hours.length > 0) {
      return this.hours.map(hour => hour.formattedTimeSlot).join("\n");
    }
    return "Closed";
  }

  static fromJson(json: Record<string, any>): OpeningTimeDay {
    return new OpeningTimeDay({
      h24: json.h24,
      hours: (json.hours as Array<any>)
        .map(slot => OpeningTimeSlot.fromJson(slot))
    });
  }

  toJson(): Record<string, any> {
    return {
      h24: this.h24,
      hours: this.hours.map(hour => hour.toJson())
    };
  }
}
